import axiosInstance from "./axiosInstance";

const appointmentService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/appointment/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllAppointments: async () => {
        try {
            const response = await axiosInstance.get('/appointment/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/appointment/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAppointmentById: async (id) => {
        try {
            const response = await axiosInstance.get(`/appointment/get/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/appointment/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/appointment/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default appointmentService;